// extracted by mini-css-extract-plugin
module.exports = {"container":"AgainstCorruption_container__xQGXq","text":"AgainstCorruption_text__30tIf"};